import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactElement } from 'react'
import { Alert as BootstrapAlert, Row, Col } from 'react-bootstrap'
import { AlertMessage } from 'types'

interface IProps {
    heading?: string
    alert?: AlertMessage,
    dismissible?: boolean,
    onClose?: () => void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [x: string]: any;
}
const MessageAlert = ({ heading, alert, dismissible, onClose, ...otherProps }: IProps) => {

    if (!alert || !alert.messages || alert.messages.length === 0)
        return (<></>)

    const getIcon = (variant: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light') => {
        switch (variant) {
            case 'info':
                return <><FontAwesomeIcon icon={['fas', 'info-circle']} />&nbsp;</>
            case 'success':
                return <><FontAwesomeIcon icon={['fas', 'check-circle']} />&nbsp;</>
            case 'warning':
                return <><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />&nbsp;</>
            case 'danger':
                return <><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />&nbsp;</>
            default:
                return <></>
        }
    }

    return (
        <Row className='mt-2' {...otherProps}>
            <Col>
                <BootstrapAlert variant={alert.variant} show={alert.messages.length > 0} dismissible={dismissible} onClose={onClose}>
                    {
                        heading
                            ? <BootstrapAlert.Heading>{heading}</BootstrapAlert.Heading>
                            : <></>
                    }

                    {alert.messages.length === 1
                        // single message
                        ? <div>
                            {getIcon(alert.variant)}
                            {
                                typeof alert.messages[0] === 'string'
                                    ? <span>{alert.messages[0]}</span>
                                    : <span>{alert.messages[0]}</span>
                            }
                        </div>
                        // multiple messages so use a ul instead
                        : <ul>
                            {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                alert.messages.map((value: string | ReactElement<any>) =>
                                    <li>
                                        {
                                            typeof value === 'string'
                                                ? <span>{value}</span>
                                                : <span>{value}</span>
                                        }
                                    </li>
                                )}
                        </ul>
                    }
                </BootstrapAlert>
            </Col>
        </Row >
    )
}

MessageAlert.defaultProps = {
    heading: undefined,
    alert: undefined
}
export default MessageAlert